import React from 'react';

interface PulseWaveIconProps {
  className?: string;
}

export function PulseWaveIcon({ className = 'h-6 w-6' }: PulseWaveIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      {/* EKG-style pulse wave path - 2x amplitude */}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2 12h2l2-8 3 16 2-12 2 8 2-4h7"
      />
    </svg>
  );
}

export default PulseWaveIcon;
